import EventParticipantList from "./EventParticipantList";

export default EventParticipantList;
